module.exports = __webpack_public_path__ + "media/three-coin1.b7bc4bbc.mp3";